import {isArrayNullUndefinedOrEmpty, isNullOrUndefined} from "../../services/Validator";
import SystemFullScreenError from "../../components/errors/SystemFullScreenError";
import {kExerciserResultsError} from "../../constants/errors";
import ExerciserResultsContentLayout from "../../components/layouts/courses/exercisers/ExerciserResultsContentLayout";
import ExerciserResultsTabletContentLayout
    from "../../components/layouts/courses/exercisers/ExerciserResultsTabletContentLayout";
import ExerciserResultsTabletSummary from "../../components/others/courses/exercisers/ExerciserResultsTabletSummary";
import ExerciserResultsDesktopContentLayout
    from "../../components/layouts/courses/exercisers/ExerciserResultsDesktopContentLayout";
import ExerciserResultsDesktopSummaryLayout
    from "../../components/layouts/courses/exercisers/ExerciserResultsDesktopSummaryLayout";
import ExerciserResultsDesktopScoreCard
    from "../../components/cards/courses/exercisers/ExerciserResultsDesktopScoreCard";
import ExerciserResultsDesktopGraphCard
    from "../../components/cards/courses/exercisers/ExerciserResultsDesktopGraphCard";
import ExerciserResultsDesktopQuestionsCard
    from "../../components/cards/courses/exercisers/ExerciserResultsDesktopQuestionsCard";
import ExerciserResultsTabletQuestionsCard
    from "../../components/cards/courses/exercisers/ExerciserResultsTabletQuestionsCard";
import NeoExerciserResultsTopBar from "../../components/bars/exerciserScreen/NeoExerciserResultsTopBar";
import SystemLeaveExerciserDialog from "../../components/dialogs/SystemLeaveExerciserDialog";
import {useState} from "react";

export default function NeoExerciserResultsScreen({ problem,
                                                    leaveExerciser }) {
    // Used in Exerciser to display exercisers end results

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)
    const totalQuestions = problem?.questions?.length

    // BUILD
    if (isArrayNullUndefinedOrEmpty(problem))
        return <SystemFullScreenError error={kExerciserResultsError} />
    return (
        <div className="overflow-auto animate-appear w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** ---- MODAL */}
            <SystemLeaveExerciserDialog open={isModalOpen}
                                        handleClose={processModalClosing}
                                        leave={leaveExerciser} />
            {/** TOP BARS */}
            <NeoExerciserResultsTopBar levelA={problem.levelA}
                                       onButtonClick={processModalOpening} />
            {/** CORE */}
            <ExerciserResultsContentLayout>
                {/** ---- TABLET */}
                <ExerciserResultsTabletContentLayout>
                    <ExerciserResultsTabletSummary scores={computeExerciserScores()[0]}
                                                   total={totalQuestions} />
                    <ExerciserResultsTabletQuestionsCard levelA={problem.levelA}
                                                         questions={problem?.questions} />
                </ExerciserResultsTabletContentLayout>
                {/** ---- DESKTOP */}
                <ExerciserResultsDesktopContentLayout>
                    <ExerciserResultsDesktopSummaryLayout>
                        <ExerciserResultsDesktopScoreCard scores={computeExerciserScores()[0]}
                                                          total={totalQuestions} />
                        <ExerciserResultsDesktopGraphCard scores={computeExerciserScores()[0]} />
                    </ExerciserResultsDesktopSummaryLayout>
                    <ExerciserResultsDesktopQuestionsCard levelA={problem.levelA}
                                                          questions={problem?.questions} />
                </ExerciserResultsDesktopContentLayout>
            </ExerciserResultsContentLayout>
        </div>
    )

    // METHODS
    // ---- Compute exercisers scores
    function computeExerciserScores() {
        // Prepare
        let scores = [0, 0]
        // Compute
        for (let i = 0; i < problem?.questions.length; i++) {
            // Scores
            if (isNullOrUndefined(problem.questions[i].userSubmission)) {
                // Case : userAnswer not found
                scores[1] += 1
            } else {
                // Case : userAnswer found
                problem.questions[i].userSubmission.isCorrect ? scores[0] += 1 : scores[1] += 1
            }
        }
        // Return
        return [scores]
    }

    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}